import StatusProgressSuccess from './StatusProgressSuccess'

export default StatusProgressSuccess
